module.exports = __webpack_public_path__ + "img/4.426e962e.jpg";